import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-user-change-password',
	templateUrl: './user-change-password.component.html',
	styleUrls: ['./user-change-password.component.scss'],
})
export class UserChangePasswordComponent implements OnInit {
	passwordForm: FormGroup;
	loading = true;
	isEditing = false;

	wrongPassword = false;
	wrongConfirmation = false;
	missingRequirements = false;

	constructor(
		public userService: UserService,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private toastr: ToastrService,
		private router: Router
	) {}

	ngOnInit() {
		this.loading = false;

		this.initPassForm();
	}

	initPassForm(): void {
		this.passwordForm = this.fb.group({
			currentPassword: ['', Validators.required],
			newPassword: ['', [Validators.required]],
			newPasswordConfirmation: ['', [Validators.required]],
			updateOn: 'blur',
		});
	}

	changePassword() {
		const currentPassword = this.passwordForm.value.currentPassword;
		const newPassword = this.passwordForm.value.newPassword;
		const newPasswordConfirmation =
			this.passwordForm.value.newPasswordConfirmation;

		if (newPassword.length < 6) {
			this.missingRequirements = true;

			alert('A senha deve conter pelo menos 6 caracteres!');

			setTimeout(() => {
				this.missingRequirements = false;
			}, 3000);
			return;
		}

		const specialCaracters = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
		if (!specialCaracters.test(newPassword)) {
			this.missingRequirements = true;

			alert('A senha deve conter pelo menos um caractere especial!');

			setTimeout(() => {
				this.missingRequirements = false;
			}, 3000);
			return;
		}

		if (newPassword !== newPasswordConfirmation) {
			this.wrongConfirmation = true;

			alert('As senhas não conferem!');

			setTimeout(() => {
				this.wrongConfirmation = false;
			}, 3000);
			return;
		}

		this.userService
			.updateUserPassword(currentPassword, newPassword)
			.subscribe((res) => {
				if (res.status === 'ok') {
					this.toastr.success('Senha alterada com sucesso.');

					setTimeout(() => {
						this.router.navigate(['/home']);
					}, 3000);
				} else {
					this.wrongPassword = true;
					this.toastr.error('Senha atual incorreta!');

					setTimeout(() => {
						this.wrongPassword = false;
					}, 3000);
				}
			});
	}
}
